// src/pages/NotFound.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './PageStyles.css';

const NotFound = () => {
  return (
    <div className="page-container text-center">
      <h1>404</h1>
      <h2>Halaman Tidak Ditemukan</h2>
      <p>Maaf, halaman yang Anda cari tidak ada.</p>
      <Link to="/">Kembali ke Halaman Utama</Link>
    </div>
  );
};

export default NotFound;